import React, { useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Typography } from "@mui/material";
import { InsertDriveFile, Download } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { RecentDocument } from "../../types/folderTypes";
import FileViewerModal from "./FileViewerModal";


interface RecentDocumentsTableProps {
    recentDocuments: RecentDocument[];
    userRole: string;
    isCompanyAdmin: string;
    handleDocumentClick: (path: string) => void;
    handleDownloadFile: (id: string, name: string) => void;
    renderActionChip: (actionType: string) => React.ReactNode;
    handleFolderClick: (folderId: string) => void;
}

const RecentDocumentsTable: React.FC<RecentDocumentsTableProps> = ({
    recentDocuments,
    userRole,
    isCompanyAdmin,
    handleDocumentClick,
    handleDownloadFile,
    renderActionChip,
    handleFolderClick,
}) => {
    const navigate = useNavigate();

    const [viewerDoc, setViewerDoc] = useState<RecentDocument | null>(null);

    if (recentDocuments.length === 0) return null;

    return (
        <div className="mt-8">
            <Typography variant="h6" className="font-bold text-gray-900 mb-2">
                Recent Documents
            </Typography>
            <TableContainer className="bg-white rounded-lg shadow-md">
                <Table>
                    <TableHead className="bg-gray-100">
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Last Updated</TableCell>
                            <TableCell>Updated By</TableCell>
                            <TableCell>Action Type</TableCell>
                            <TableCell>Folder</TableCell>
                            {(userRole === 'superadmin' || userRole === 'admin' || (userRole === 'user' && isCompanyAdmin === "1")) && (
                                <TableCell>Actions</TableCell>
                            )}
                            {/* <TableCell>Actions</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {recentDocuments.map((doc: RecentDocument) => (
                            <TableRow key={doc.id} className="hover:bg-gray-50">
                                <TableCell className="flex items-center">
                                    <InsertDriveFile className="text-gray-600 text-4xl mr-2" />
                                    <span
                                        className="text-blue-500 cursor-pointer hover:underline"
                                        // onClick={() => handleDocumentClick(doc.document_path)}
                                        onClick={() => setViewerDoc(doc)}
                                    >
                                        {doc.document_name}
                                    </span>
                                </TableCell>
                                <TableCell>
                                    {new Date(doc.updated_at).toLocaleString("en-GB", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: false,
                                    })}
                                </TableCell>
                                <TableCell className="text-center">
                                    {doc.updated_by === "Unknown" ? "-" : doc.updated_by}
                                </TableCell>
                                <TableCell className="text-center">
                                    <span className="capitalize text-sm font-medium text-gray-700">
                                        {doc.action_type === "unknown" ? "-" : renderActionChip(doc.action_type)}
                                    </span>
                                </TableCell>
                                <TableCell>
                                    {doc.folder && (
                                        <span
                                            className="text-blue-500 cursor-pointer hover:underline"
                                            onClick={() => handleFolderClick(String(doc.folder?.id))}
                                        >
                                            {doc.folder.folder_name}
                                        </span>
                                    )}
                                </TableCell>
                                {(userRole === 'superadmin' || userRole === 'admin' || (userRole === 'user' && isCompanyAdmin === "1")) && (
                                    <TableCell>

                                        <IconButton color="primary" size="small" onClick={() => handleDownloadFile(doc.id.toString(), doc.document_name)}>
                                            <Download />
                                        </IconButton>
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <FileViewerModal document={viewerDoc} onClose={() => setViewerDoc(null)} />
        </div>
    );
};

export default RecentDocumentsTable;
